
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import type { FormData } from "./types";

interface Constituency {
  code: string;
  name: string;
  country_code: string;
}

interface Props {
  constituencies: Constituency[];
  formData: FormData;
  setFormData: (data: FormData) => void;
}

const EditUserConstituencySelect = ({ constituencies, formData, setFormData }: Props) => (
  <div className="grid gap-2">
    <Label htmlFor="constituency">Constituency</Label>
    <Select
      value={formData.constituency_code}
      onValueChange={(value) =>
        setFormData({ ...formData, constituency_code: value })
      }
      disabled={!formData.country_code || constituencies.length === 0}
    >
      <SelectTrigger>
        <SelectValue placeholder={
          !formData.country_code
            ? "Select a country first"
            : constituencies.length === 0
              ? "No constituencies available"
              : "Select a constituency"
        } />
      </SelectTrigger>
      <SelectContent>
        {constituencies.map((constituency) => (
          <SelectItem key={constituency.code} value={constituency.code}>
            {constituency.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  </div>
);

export default EditUserConstituencySelect;
